var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06389 1.09488C5.13859 1.18559 5.18435 1.29659 5.19527 1.41355C5.20618 1.53051 5.18174 1.64806 5.12511 1.751C4.6827 2.56272 4.45165 3.47258 4.45324 4.39688C4.45324 7.47176 6.96168 9.96165 10.0532 9.96165C10.4565 9.96165 10.8491 9.91959 11.2263 9.83929C11.342 9.81427 11.4625 9.82384 11.5727 9.86682C11.6829 9.90979 11.7781 9.98427 11.8462 10.0809C11.9181 10.1815 11.9548 10.3029 11.9505 10.4264C11.9462 10.5499 11.9012 10.6685 11.8225 10.7638C11.2223 11.5006 10.4651 12.0942 9.60621 12.5014C8.7473 12.9086 7.80828 13.1191 6.85761 13.1176C3.32987 13.1176 0.472473 10.2775 0.472473 6.77818C0.472473 4.14453 2.09018 1.88559 4.39355 0.928176C4.50829 0.879718 4.63566 0.869773 4.75654 0.899833C4.87741 0.929893 4.98527 0.998337 5.06389 1.09488Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.12457c9fd019bd7f5b7bb0a2c852e9da.svg";
export { ForwardRef as ReactComponent };